import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f69aac5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "seat-selection-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "좌석선택", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "target-date"
}
const _hoisted_5 = {
  key: 0,
  class: "duplicate-message"
}
const _hoisted_6 = {
  key: 0,
  class: "contents-area"
}
const _hoisted_7 = { class: "auto-selection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "선점좌석 자동배정", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" 선택한 일정 중 가장 빠른 일자를 기준으로 모두 동일한 좌석으로 예약이 진행됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 만약 선택한 좌석이 예약 불가일 경우에는 별도로 좌석을 지정할 수 있으며, ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, " [선점좌석 자동배정]을 선택하시면 예약 가능한 좌석으로 자동으로 선택된 후 예약이 진행 "),
  /*#__PURE__*/_createElementVNode("span", { class: "after-highlight" }, " 됩니다. (만석 및 미선택시에는 해당 좌석은 제외 후 예약 진행) ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          (!!$setup.dateToShow)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString($setup.dateToShow) + ")", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        (!!$props.duplicateSeatNo)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " 예약된 좌석입니다. 다른 좌석을 선택하세요. "))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.shouldShowSeats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode($setup["SeatsLayoutSwiper"], {
                ref: "seatLayoutWrapper",
                seatsInfosList: $setup.seatsInfosList,
                seatsRowsNumList: $setup.seatsRowsNumList,
                seatsColumnsNumList: $setup.seatsColumnsNumList,
                mySeatNo: $props.selectedDateInfo?.bookableDate?.mySeatNo,
                selectable: true,
                duplicateSeatNo: $props.duplicateSeatNo,
                onOnClickSeat: $setup.onClickSeat
              }, null, 8 /* PROPS */, ["seatsInfosList", "seatsRowsNumList", "seatsColumnsNumList", "mySeatNo", "duplicateSeatNo"])
            ]),
            _createElementVNode("section", _hoisted_7, [
              _createVNode($setup["CheckboxInput"], {
                class: "checkbox",
                value: $props.autoSeatAssign,
                onOnChangedCheck: $setup.onChangedAutoSeatAssign
              }, null, 8 /* PROPS */, ["value"]),
              _hoisted_8,
              _createElementVNode("button", {
                class: "help",
                onClick: $setup.onClickAutoAssginHelp
              }, [
                _createVNode($setup["InlineSvg"], {
                  class: "img-help",
                  src: require('@/assets/icons/help_circle.svg'),
                  alt: "도움말"
                }, null, 8 /* PROPS */, ["src"])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.shouldShowAutoAssignInfoModal)
      ? (_openBlock(), _createBlock($setup["InfoModal"], {
          key: 0,
          title: "좌석안내",
          confirmButtonTitle: "닫기",
          onOnClickConfirmButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowAutoAssignInfoModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}